import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import HotelImageCarousel from "../../pages/MainPage/HotelImageCarousel";
import {
  addHotelAddon,
  removeHotelAddon,
} from "../../redux/actions/hotelInfoAction";
import { currency } from "../../utils/currency";
import { fireGtmEvent } from "../../utils/googleAnalytics";
import useWindowSize from "../../utils/useWindowSize";
import "./HotelAddonComponent.css";
import { useTranslation } from "react-i18next";

const HotelAddonComponent = ({ addon, isCheckout = false }) => {
  const [selected, setSelected] = useState(false);
  const [count, setCount] = useState(0);
  const { hotelData, selectedHotelAddons, dateCount } = useSelector(
    (state) => state.hotelInfo
  );

  const { width } = useWindowSize();

  useEffect(() => {
    // if (selectedHotelAddons?.length > 0) {
    setCount(
      selectedHotelAddons?.filter((adn) => adn?.id === addon?.id).length
    );
    // }
    selectedHotelAddons?.filter((adn) => adn?.id === addon?.id)[0]?.id ===
    addon?.id
      ? setSelected(true)
      : setSelected(false);
  }, [selectedHotelAddons]);

  const dispatch = useDispatch();

  const selectAddon = () => {
    if (count < 10) {
      dispatch(addHotelAddon(addon));
      fireGtmEvent("hotel_addon_selected", {
        addon_id: addon?.addonId,
        addon_name: addon?.Addon?.name,
        is_hotel_addon_images: addon?.HotelAddonImages?.length > 0,
        hotel_addon_images_count: addon?.HotelAddonImages?.length,
        value: addon?.price,
      });
    }
  };

  const deSelectAddon = () => {
    if (count > 0) {
      dispatch(removeHotelAddon(addon));
      fireGtmEvent("hotel_addon_removed", {
        addon_id: addon?.addonId,
        addon_name: addon?.Addon?.name,
        is_hotel_addon_images: addon?.HotelAddonImages?.length > 0,
        hotel_addon_images_count: addon?.HotelAddonImages?.length,
        value: addon?.price,
      });
    }
  };

  const { t } = useTranslation();

  return (
    // <LazyLoadComponent>
    <div
      className={isCheckout && width > 900 ? "checkoutAddon" : "hAddon"}
      id="hAddon"
    >
      <div className="hAddonImage">
        <HotelImageCarousel
          name={addon.Addon.name}
          hotelImages={addon?.HotelAddonImages || addon?.Addon?.url}
          isAddon={true}
        />
      </div>

      <div className={isCheckout && width > 900 ? "newCheckoutAdon" : ""}>
        <h3 className="hAddonName">{addon?.name}</h3>
        <div
          className="hAddonDescription"
          style={{ border: isCheckout && width > 900 && "none" }}
          dangerouslySetInnerHTML={{ __html: addon.description }}
        />
        <div className="hAddonPrice">
          <p>
            {currency(hotelData?.currency)} {addon?.price}{" "}
            {addon.Addon.multiplier === "per_day" ? "/ day" : ""}{" "}
            <span style={{ fontWeight: "400", fontSize: "0.7rem" }}>
              ({t("incl_of_taxes")})
            </span>
          </p>
          {selected ? (
            <div className="hAddonAdded">
              <span className="hAddonIcon" onClick={deSelectAddon}>
                -
              </span>
              {count}
              <span className="hAddonIcon" onClick={selectAddon}>
                +
              </span>
            </div>
          ) : (
            <div
              className="hAddonAdd hAddonAddHotel"
              onClick={() => selectAddon()}
            >
              {t("add")}
            </div>
          )}
        </div>
        {count > 0 && addon.Addon.multiplier === "per_day" && !isCheckout && (
          <div className="hAddonNote">
            {count} {addon?.name} {t("is_selected_for")}{" "}
            <b>
              {dateCount} {t("days")}
            </b>
          </div>
        )}
      </div>
    </div>
    // </LazyLoadComponent>
  );
};

export default HotelAddonComponent;
